module.exports = __webpack_public_path__ + "static/media/sport-active.9e1cb3e7.png";